import { IconButton, useTheme } from "@mui/material";
import { Ellipsis } from "lucide-react";
import { useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailSectionLoader } from "web_myplann/Portfolio/Components/DetailSectionLoader";
import { ContactDrawer } from "web_myplann/Shared/Components/ContactDrawer";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import { MyPlannNavigationHeader } from "web_myplann/Shared/Header/MyPlannNavigationHeader";
import { getBackFallbackRoute } from "web_myplann/Shared/Utils/backNavigation";
import { getTypedParam } from "web_myplann/Shared/Utils/getTypedParam";
import { TaskBasicInfoSection } from "web_myplann/Tasks/Components/TaskBasicInfoSection";
import { TaskProcessSection } from "web_myplann/Tasks/Components/TaskProcessSection";
import { useTaskDetail } from "web_myplann/Tasks/Hooks/useTaskDetail";

const R = Resources.Task.Detail;

export const TaskDetailV2Page = () => {
	const routeParams = useParams<{ id: string }>();
	const taskId = getTypedParam(routeParams, "id", Number) ?? null;
	const theme = useTheme();
	const { t } = useResource();
	const location = useLocation();

	const [contactOpen, setContactOpen] = useState(false);

	const { task, phases, hasMoreAgents, isLoading, contactPhone, contactEmail } =
		useTaskDetail(taskId);

	return (
		<>
			<MyPlannLayout
				disableContentPadding
				bgColor={theme.palette.surface.muted}
				topBar={
					<MyPlannNavigationHeader
						title={t(R.title)}
						bgColor={theme.palette.background.paper}
						defaultRoute={getBackFallbackRoute(location.pathname)}
						replaceOnBack
						endComponent={
							<IconButton variant="ghost" onClick={() => setContactOpen(true)}>
								<Ellipsis
									size={theme.iconSize.md}
									color={theme.palette.grey[700]}
								/>
							</IconButton>
						}
					/>
				}
			>
				{isLoading ? (
					<DetailSectionLoader />
				) : (
					task && (
						<>
							<TaskBasicInfoSection task={task} hasMoreAgents={hasMoreAgents} />
							<TaskProcessSection phases={phases} />
						</>
					)
				)}
			</MyPlannLayout>
			<ContactDrawer
				open={contactOpen}
				onClose={() => setContactOpen(false)}
				phone={contactPhone}
				email={contactEmail}
			/>
		</>
	);
};
